import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

/**
 * Uniform container for row-level table actions.
 *
 * Every `DataTable` action column follows one rule (see `design-system.md` →
 * Tables): declare the column `{ header: 'Actions', align: 'left' }` and render
 * its buttons inside `<RowActions>`. This guarantees the action group sits at
 * the row's leading edge — left-aligned under its header, Glide-style — with
 * consistent spacing across every table, single button or several.
 */
export default function RowActions({
    children,
    className,
}: {
    children: ReactNode;
    className?: string;
}) {
    return (
        <div className={cn('flex items-center justify-start gap-1.5', className)}>{children}</div>
    );
}
